module.exports = __webpack_public_path__ + "img/signal_cellular_null.bc52fe23.svg";